import { render, staticRenderFns } from "./ItemSetStackSizeDialog.vue?vue&type=template&id=e309457e&scoped=true&"
import script from "./ItemSetStackSizeDialog.vue?vue&type=script&lang=ts&"
export * from "./ItemSetStackSizeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e309457e",
  null
  
)

export default component.exports